export class DeliverClothesModel {

    codigo: string;
    descrp: string;
    grupoSZ: string;
    cantdRec: number;
    cantd: number;
    talla: string;
    entrega: boolean;

    constructor() { }
}